// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__314XE","title":"ClientReferral_title__1kIF3","itemText":"ClientReferral_itemText__QpAmQ"};